import Home from "~/lib/components/views/home";
import { useEffect } from "react";
import { dehydrate } from "react-query";
import { getPromotedArticlesQuery } from "~/services/queries/zendesk.queries";
import { getHelpCentreConfigs } from "~/services/variables.service";
import { getSeoMeta } from "~/lib/utils/seo";
import { MetaFunction } from "@remix-run/react";
import { HELP_CENTER_CONSTANTS } from "~/lib/utils/const";
import { LoaderFunctionArgs } from "@remix-run/node";
import { i18next } from "~/i18n/i18n.server";
import { defaultQueryClient } from "~/lib/utils/query-client";

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const locale = await i18next.getLocale(request);

  await Promise.all([
    defaultQueryClient.prefetchQuery(getPromotedArticlesQuery(locale)),
    defaultQueryClient.prefetchQuery(["GET_ICONS"], () =>
      getHelpCentreConfigs()
    ),
  ]);

  return {
    dehydratedState: dehydrate(defaultQueryClient),
  };
};

export const meta: MetaFunction = () => {
  return getSeoMeta({
    title: HELP_CENTER_CONSTANTS.label,
    description: "Let us help you with your problems and concerns about Setel!",
    url: "https://help.setel.com/",
    image: "/images/meta-image.png",
  });
};

export default function HelpCentre() {
  useEffect(() => {
    window.history.scrollRestoration = "manual";
  }, []);
  return <Home />;
}
